export default function useFileTypeCheck() {
  const imageFormat = ['jpg', 'jpeg', 'png', 'gif'];
  const forgeViewerFormat = [
    '3dm',
    '3ds',
    'a',
    'asm',
    'asm',
    'asm',
    'brd',
    'catpart',
    'catproduct',
    'cgr',
    'collaboration',
    'dae',
    'dgn',
    'dlv3',
    'dwf',
    'dwfx',
    'dwg',
    'dwt',
    'dxf',
    'emode',
    'exp',
    'f2d',
    'f3d',
    'fbx',
    'g',
    'gbxml',
    'glb',
    'gltf',
    'iam',
    'idw',
    'ifc',
    'ige',
    'iges',
    'igs',
    'ipt',
    'iwm',
    'jt',
    'max',
    'model',
    'mpf',
    'msr',
    'neu',
    'neu',
    'nwc',
    'nwd',
    'obj',
    'par',
    'pmlprj',
    'pmlprjz',
    'prt',
    'prt',
    'psm',
    'psmodel',
    'rvt',
    'sab',
    'sat',
    'sch',
    'session',
    'skp',
    's3m',
    'sldasm',
    'sldprt',
    'ste',
    'step',
    'stl',
    'stla',
    'stlb',
    'stp',
    'stpz',
    'vue',
    'wire',
    'x_b',
    'x_t',
    'xas',
    'xpr',
  ];
  const pdftronFormat = ['pdf', 'csv'];

  const typeChecker = (format: string[], type?: string) => {
    if (!type) return false;
    return format.includes(type) ? true : false;
  };

  return {
    imageFormat,
    forgeViewerFormat,
    pdftronFormat,
    typeChecker,
  };
}
